import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { isEnrollmentDateAvailable } from '../../lib/utils';
import { apis } from '../../services/alm';
import LearningProgramCard from './LearningProgramCard';
import getLocalizedContent from '../../lib/getLocalizedMetaData';

const LearningProgramList = ({
  overviewTag,
  quaterData,
  programCountEachQuarter,
  year,
  islisting,
  quaterTag
}: {
  overviewTag: any;
  quaterData: object | any;
  programCountEachQuarter: any;
  year: any
  islisting:boolean;
  quaterTag:any
}) => {
  const [learningProgramData, setlearningProgramData] = useState({ data: [], included: [] });
  const [enrolledData, setEnrolledData] = useState<any>([]);
  const navigate = useNavigate();
  const [query] = useSearchParams();
  const location = useLocation()
  const programId: any = query.get('programId');
  const enrolled: any = query.get('enrolled');
  const isEnrolled: any = location?.state?.enrolled;

  React.useEffect(() => {
    const learningProgram = async () => {
      try {
        const response: any = await apis.getLearningProgram(
          quaterData?.quarter + '-' + quaterData?.year
        );
        if (programId) {
          const filteredData = response?.data?.filter((res: any) => {
            return res?.id !== programId;
          });
          setlearningProgramData({ data: filteredData, included: response?.included });
        }
      } catch (error) {
        console.log(error);
      }
    };
    if (programId && quaterData) {
      learningProgram();
    }
  }, [overviewTag, quaterData]);
  
 
  useEffect(()=>{
    if(islisting){
      const fetchData =async ()=>{
            const response: any = await apis.getLearningProgram(quaterTag);
            const enrolledData = response?.data?.filter((item: any) => {
              return item.relationships.enrollment;
            });
            setEnrolledData(enrolledData)
          }
            fetchData();
    }
  },[islisting])

  return (
    <>
      {learningProgramData?.data?.sort((a: any, b: any) => b?.attributes?.localizedMetadata[0]?.name.localeCompare(a?.attributes?.localizedMetadata[0]?.name, 'es', { sensitivity: 'base' }))?.slice(0, 1).map((res: any, index: number) => {
        const url = `/program-overview?programId=${res?.id}${
            isEnrolled ? !enrolled ?`&enrolled=true` :"":""
        }`
        return (
          <div
            key={`program-listing-${index}`}
            className="mt-10 w-full max-w-[560px] md:w-[560px] "
            onClick={() => 
              navigate(
                url, {
                state: {
                  enrolled: enrolledData[0]?.relationships?.enrollment?.data?.id
                  ? enrolledData[0]?.relationships?.enrollment?.data?.id
                  : false,
                  enrolledName: getLocalizedContent(enrolledData[0]?.attributes?.localizedMetadata).name,
                  year: year,
                  programCountEachQuarter: programCountEachQuarter
                },
              }
              )}
            
          >
            {index <= 3 && (
              <LearningProgramCard
                isEnrollmentOpen={isEnrollmentDateAvailable(quaterData?.start)}
                responseData={learningProgramData}
                quarterStartDate={quaterData?.start}
                cardInfo={res}
                quater={overviewTag[0]?.split('-')[0]}
              />
            )}
          </div>
        );
      })}
    </>
  );
};

export default LearningProgramList;
